export const AppName = process.env.VUE_APP_NAME

export const ALL_MEMBERS_ID = 'allmembers'

export const INSPIRATION_DEFAULT = require('@/assets/images/inspiration-default.jpg')
